<template>
  <span
    class="Block"
    :style="
      `background-color: ${rgba ('--wc3-' + converted)};` +
      `width: ${size}px;` +
      `height: ${size}px;`
    "
    v-tooltip="capitalize (converted)"
  ></span>
</template>

<script>
  import { rgba, codeToColour, capitalize } from '@/legacy/lib//template';

  export default {
    props: {
      colour: {
        type: [ String, Number ],
        default: 0
      },

      size: {
        type: Number,
        default: 20
      }
    },

    methods: {
      rgba,
      codeToColour,
      capitalize
    },

    computed: {
      converted () {
        if (typeof this.colour === 'string') {
          return this.colour;
        }

        return codeToColour (this.colour);
      }
    }
  }
</script>

<style lang="scss">
  .Block {
    display: inline-block;
    vertical-align: middle;
    background-color: rgba(var(--white), .2);

    &--Circle {
      border-radius: 1000px;
    }
  }
</style>